import styled from 'styled-components';
import { ReactComponent as GridViewImage } from 'Images/grid_view.svg';
import { disableTextSelection } from 'Styles/effects/text';
import Button from 'shared/ui/Button';
import { typography } from 'shared/ui/tokens';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  ${disableTextSelection}
  position: absolute;
  right: 28px;
  top: 5px;
`;
Wrapper.displayName = 'Wrapper';

export const GridViewIcon = styled(GridViewImage)`
  height: auto;
  & g > path{
    fill: ${({ theme }) => theme.icons.actionBar.color};
  }
`;
GridViewImage.displayName = 'GridViewImage';

export const CustomButton = styled(Button).attrs({ variant: 'secondary' })`
  && {
    background-color: ${({ theme }) => theme.buttons.custom.background};
    border-color: ${({ theme }) => theme.buttons.custom.border};
    color: ${({ theme }) => theme.buttons.custom.color};
    font-size: ${typography.fontSize.sm};

    &:hover {
      background-color: ${({ theme }) => theme.buttons.custom.backgroundHover};
    }
  }
`;
CustomButton.displayName = 'CustomButton';
